module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "pn"
  }, [_vm._v("I")]), _vm._v(" "), _c('p', {
    staticClass: "pt",
    attrs: {
      "id": "pt1"
    }
  }, [_vm._v("FUSION TORCH SHIP "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("AUSTRALIA")])]), _vm._v(" "), _c('p', {
    staticClass: "pep"
  }, [_vm._v("To follow knowledge like a sinking star,")]), _vm._v(" "), _c('p', {
    staticClass: "pep-bot"
  }, [_vm._v("Beyond the utmost bound of human thought.")]), _vm._v(" "), _c('p', {
    staticClass: "pepc"
  }, [_vm._v("—Alfred, Lord Tennyson"), _c('br'), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Ulysses")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02826ec8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 75
// module chunks = 0